import React, { createContext } from "react";
import { fetchCdnJson } from "./masjidIndex";

// Whether the masjid on screen has official salah times. Provided by the /home shell only, so
// wall screens never show the badge.
export const VerifiedMasjidContext = createContext(false);

const answers = new Map<number, Promise<boolean>>();

// From the masjid's details file, the same flag the website's masjid page shows. Asked once per
// masjid; a failed check means no badge and is asked again next time.
export const isVerified = (masjidId: number): Promise<boolean> => {
  if (!answers.has(masjidId)) {
    const answer = fetchCdnJson(`masaajid/${masjidId}/details.json.gz`).then(
      (details) => !!(details.IsVerified ?? details.isVerified),
    );
    answer.catch(() => answers.delete(masjidId));
    answers.set(masjidId, answer);
  }
  return answers.get(masjidId)!;
};

// The website's verified rosette, sized to the masjid name beside it.
export const VerifiedBadge: React.FC = () => (
  <svg
    viewBox="0 0 512 512"
    role="img"
    aria-label="Verified"
    style={{ width: "0.8em", height: "0.8em", marginLeft: "0.3em", verticalAlign: "-0.05em" }}
  >
    <path
      d="M256 472.153L176.892 512l-41.725-81.129-86.275-16.654 11.596-91.422L0 256l60.488-66.795-11.596-91.422 86.275-16.654L176.892 0 256 39.847 335.108 0l41.725 81.129 86.275 16.654-11.596 91.422L512 256l-60.488 66.795 11.596 91.422-86.275 16.654L335.108 512z"
      style={{ fill: "var(--home-badge, #8591F3)" }}
    />
    <path
      d="M211.824 284.5L171 243.678l-36 36 40.824 40.824-.063.062 36 36 .063-.062.062.062 36-36-.062-.062L376.324 192l-36-36z"
      fill="#fff"
    />
  </svg>
);
